import "./style.css";
import * as THREE from "three";
//import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
//import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
//import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import * as dat from "lil-gui";
import './style.css'
//import * as THREE from 'three'
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
//import * as dat from 'dat.gui'

let camera, scene, renderer, gui, aspect, container;
let width = 0, height = 0;
let onPointerDownPointerX, onPointerDownPointerY, onPointerDownLon, onPointerDownLat
let lon = 0, lat = 0;
let filename = "normal_map_rotated.png";

const params = {
  rotationD: 0,
  rotationR: 0,
  flipX: false,
  flipY: false,
  flipZ: false,
  envMap: false,
  plus: function () {
    params.rotationD += 45;
    params.rotationR = params.rotationD * (Math.PI / 180)
    //gui.updateDisplay();
  },
  minus: function () {
    params.rotationD -= 45;
    params.rotationR = params.rotationD * (Math.PI / 180)
    //gui.updateDisplay();
  },
  resetRotation: resetRotation,
  zoom: 1,
  resetZoom: resetZoom,
  download: download
};

function resetRotation() {
  params.rotationD = 0;
  params.rotationR = params.rotationD * (Math.PI / 180)
  //gui.updateDisplay();
}
function resetZoom() {
  params.zoom = camera.zoom = 1
  lon = lat = 0;
  camera.updateProjectionMatrix();
  //gui.updateDisplay();
}


const sides = {
  'front': THREE.FrontSide,
  'back': THREE.BackSide,
  'double': THREE.DoubleSide

};

let cameraOrtho, cameraPerspective;
let controlsOrtho, controlsPerspective;

let mesh, materialStandard, materialDepthBasic, materialDepthRGBA, materialNormal;

init();
animate();
initGui();

// Init gui
function initGui() {

  gui = new dat.GUI({
    title: "CONTROL PANEL",
    width: "420",
    autoPlace: true
  });


  //ROTATION PARAMS
  var rotFolder = gui.addFolder('Rotation');
  rotFolder.add(params, 'rotationD', -180, 180, 1).name('Degrees').onChange(function () {
    params.rotationR = this.getValue() * (Math.PI / 180)
    //gui.updateDisplay();
  }).listen()//.listen(); //the keyboard input doesn't work with listen... updateDisplay fix

  rotFolder.add(params, 'rotationR', -Math.PI, Math.PI, 0.000001).name('Radians').listen().onChange(function () {
    params.rotationD = this.getValue() / (Math.PI / 180)
    //gui.updateDisplay();
  }).listen()//.listen();

  rotFolder.add(params, 'plus').name('Rotate +45°').listen();
  rotFolder.add(params, 'minus').name('Rotate -45°').listen();
  rotFolder.add(params, 'resetRotation').name('Reset Rotation').listen();

  //TRANSFORM PARAMS
  var transFolder = gui.addFolder('Transform');

  transFolder.add(params, 'flipX').name('Flip X').onChange(function () {
    handleFlip();
  }).listen();

  transFolder.add(params, 'flipY').name('Flip Y').onChange(function () {
    handleFlip();
  }).listen();

  transFolder.add(params, 'flipZ').name('Flip Height').onChange(function () {
    handleFlip();
  }).listen();

  function handleFlip() {
    let fx = params.flipX ? -1 : 1;
    let fy = params.flipY ? -1 : 1;
    let fz = params.flipZ ? -1 : 1;
    mesh.scale.set(2 * fx, 2 * fy, 2 * fz);
  }


  //ZOOM PARAMS
  var zoomFolder = gui.addFolder('Zoom');

  zoomFolder.add(params, 'zoom', 0.1, 10, 0.01).name('Zoom').onChange(function () {
    camera.zoom = this.getValue();
    camera.updateProjectionMatrix();
    //gui.updateDisplay();
  }).listen();

  zoomFolder.add(params, 'resetZoom').name('Reset Zoom');

  // OTHER PARAMS
  var otherFolder = gui.addFolder('Preview');

  otherFolder.add(params, 'envMap').name('Env Map').onChange(function () {
    if (this.getValue()) {
      mesh.material = materialStandard;
    } else {
      mesh.material = materialNormal;
    }
  });

  otherFolder.add(params, 'download').name('Download Map');
  //gui.add( params, 'zoom',  1,10, 0.01  ).name('Camera Z (Zoom)');

}

function init() {

  container = document.createElement('div');
  document.body.appendChild(container);



  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true, premultipliedAlpha: true });
  renderer.domElement.id = 'mainCanvas';
  //renderer.setClearColor( 0x8080FF, 1 );
  renderer.setClearColor(0x000000, 0);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.outputEncoding = THREE.sRGBEncoding;

  width = window.innerWidth;
  height = window.innerHeight;

  renderer.setSize(width, height);
  container.appendChild(renderer.domElement);



  //
  aspect = window.innerWidth / window.innerHeight;
  scene = new THREE.Scene();




  cameraOrtho = new THREE.OrthographicCamera(- height * aspect, height * aspect, height, - height, 1000, 2500);

  cameraOrtho.position.z = 1500;
  scene.add(cameraOrtho);

  camera = cameraOrtho;

  /* controlsOrtho = new OrbitControls( cameraOrtho, renderer.domElement );
  controlsOrtho.minZoom = 0.1;
  controlsOrtho.maxZoom = 10.5;
  controlsOrtho.enablePan = true;
  //controlsOrtho.enableRotate = false;
  controlsOrtho.rotateSpeed = 0;
  //controlsOrtho.enableDamping = true; */

  // lights

  /* const ambientLight = new THREE.AmbientLight( 0xffffff, 0.1 );
  scene.add( ambientLight );

  const pointLight = new THREE.PointLight( 0xff0000, 0.5 );
  pointLight.position.z = 2500;
  scene.add( pointLight );

  const pointLight2 = new THREE.PointLight( 0xff6666, 1 );
  camera.add( pointLight2 );

  const pointLight3 = new THREE.PointLight( 0x0000ff, 0.5 );
  pointLight3.position.x = - 1000;
  pointLight3.position.z = 1000;
  scene.add( pointLight3 ); */

  // textures

  const textureLoader = new THREE.TextureLoader();
  const normalMap = textureLoader.load("./normal.png");
  const envMap = textureLoader.load("./small_empty_room_1_1k.jpg");
  envMap.mapping = THREE.EquirectangularReflectionMapping;
  envMap.encoding = THREE.LinearEncoding;

  normalMap.encoding = THREE.LinearEncoding;
  //normalMap.magFilter = THREE.NearestFilter;
  //normalMap.minFilter = THREE.LinearMipMapLinearFilter;
  //normalMap.rotation = Math.PI/2;
  //normalMap.center = new THREE.Vector2(0.5, 0.5); // center of texture.

  // material


  materialStandard = new THREE.MeshStandardMaterial({
    color: 0xffffff,

    metalness: 0.99,
    roughness: 0,

    normalMap: normalMap,
    normalScale: new THREE.Vector2(1, 1),
    envMap: envMap,

    side: THREE.DoubleSide
  });


  materialNormal = new THREE.MeshNormalMaterial({

    normalMap: normalMap,
    normalScale: new THREE.Vector2(1, 1),
    //toneMapped: false,
    //flatShading: true,

    side: THREE.DoubleSide
  });

  //

  //const geometry =  new THREE.BoxGeometry(20,20,20);
  //const geometry = new THREE.PlaneBufferGeometry(24,24);
  const geometry = new THREE.PlaneGeometry(768, 768);


  mesh = new THREE.Mesh(geometry, materialNormal);
  mesh.scale.multiplyScalar(2); //unit to pixels
  //mesh.scale.x = -25;
  //mesh.rotation.x =  -Math.PI/4;
  scene.add(mesh);



  //
  //Drag'n'drop / Paste
  initDragAndDrop();
  initPaste();
  //
  window.addEventListener('resize', onWindowResize);
  //Controls
  container.addEventListener('pointerdown', onPointerDown);
  document.addEventListener('wheel', onDocumentMouseWheel, {
    passive: false // prevens chrome zoom
  });

}

function onWindowResize() {

  width = window.innerWidth;
  height = window.innerHeight;
  aspect = window.innerWidth / window.innerHeight;

  camera.aspect = aspect;

  camera.left = - height * aspect;
  camera.right = height * aspect;
  camera.top = height;
  camera.bottom = - height;
  camera.updateProjectionMatrix();

  renderer.setSize(width, height);

}

//

function animate() {

  requestAnimationFrame(animate);

  render();

}

function render() {


  mesh.rotation.z = -params.rotationD * (Math.PI / 180);
  camera.position.x = -lon * (2 / camera.zoom);
  camera.position.y = lat * (2 / camera.zoom);
  //controlsOrtho.update(); // must update both controls for damping to complete
  //controlsOrtho.zoom = params.zoom;
  //console.log(camera.zoom);

  camera.updateProjectionMatrix();

  //camera.lookAt( scene.position );

  renderer.render(scene, camera);

}




//Custom Pan/Zoom Controls

function onPointerDown(event) {

  //event.preventDefault();

  onPointerDownPointerX = event.clientX;
  onPointerDownPointerY = event.clientY;

  onPointerDownLon = lon;
  onPointerDownLat = lat;

  container.addEventListener('pointermove', onPointerMove, false);
  container.addEventListener('pointerup', onPointerUp, false);


}

function onPointerMove(event) {

  lon = (event.clientX - onPointerDownPointerX) + onPointerDownLon;
  lat = (event.clientY - onPointerDownPointerY) + onPointerDownLat;


}

function onPointerUp() {

  container.removeEventListener('pointermove', onPointerMove);
  container.removeEventListener('pointerup', onPointerUp);

}

function onDocumentMouseWheel(e) {
  e.preventDefault();
  e.stopPropagation();

  //CTRL Zoom
  if (e.ctrlKey) {
    let zoom = camera.zoom - e.deltaY * 0.0005;
    params.zoom = camera.zoom = THREE.MathUtils.clamp(zoom, 0.1, 10);
  } else if (e.shiftKey) {
    // Fine Rotate
    params.rotationD -= e.deltaY * 0.005;
    params.rotationR = params.rotationD * (Math.PI / 180)

  } else {
    // Coarse rotate
    params.rotationD -= e.deltaY * 0.15;
    params.rotationR = params.rotationD * (Math.PI / 180)
  }


  camera.updateProjectionMatrix();
}


//Reset on spacebar
document.body.onkeyup = function (e) {
  if (e.key == " " ||
    e.code == "Space" ||
    e.keyCode == 32
  ) {
    resetRotation();
    resetZoom();
  }
}




//Normal Map File Handling

function updateNormalMap(texture) {

  if (mesh.material.normalMap) {

    mesh.material.normalMap.dispose();

  }

  materialStandard.normalMap = materialNormal.normalMap = texture;



  texture.needsUpdate = true;

  mesh.material.needsUpdate = true; // because the encoding can change

  render();

}

//Fix plane proportions to image ratio
function updatePlaneSize(w, h) {
  //mesh.scale.x = w/h * mesh.scale.y;
  //mesh.geometry.width = w;
  //mesh.geometry.height = h;
  //mesh.scale.set( w, h, 1 );

  const geometry = new THREE.PlaneGeometry(w, h);
  mesh.geometry = geometry;

  //mesh.updateMatrix();

}


function initDragAndDrop() {

  document.addEventListener('dragover', function (event) {

    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';

  });

  document.addEventListener('drop', function (event) {

    event.preventDefault();

    loadFile(event.dataTransfer.files[0]);


  });

}
let theFile;
function loadFile(file) {

  filename = file.name.split('.')[0];
  theFile = file;
  //console.log('file', file);
  //const extension = filename.split( '.' ).pop().toLowerCase();

  // 'jpg', 'png'

  const reader = new FileReader();
  reader.addEventListener('load', function (event,file) {
    console.log('file_appended',theFile);
    //console.log('event',event);

    handleJPG(event,theFile);
    

  });

  reader.readAsDataURL(file);

}


function handleJPG(event,file) { // PNG, too

  function imgCallback(event) {
    const img = event.target;
    const maxDimension = Math.max(img.width, img.height);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    // Set canvas dimensions to the larger of the two dimensions
    canvas.width = maxDimension;
    canvas.height = maxDimension;

    // Fill canvas with padding color
    context.fillStyle = '#7F7FFF'; // Set padding color here
    context.fillRect(0, 0, canvas.width, canvas.height);

    // Calculate padding
    const xPadding = (maxDimension - img.width) / 2;
    const yPadding = (maxDimension - img.height) / 2;

    // Draw image onto canvas with padding
    context.drawImage(img, xPadding, yPadding);

    // Create texture from canvas
    const texture = new THREE.Texture(canvas);
    texture.encoding = THREE.LinearEncoding;

    updatePlaneSize(texture.image.width, texture.image.height);
    updateNormalMap(texture);
    
    // Convert canvas to base64
    //const base64Data = canvas.toDataURL('image/png');

    // Send file to upload.php for debugging/analysis. 
    
    // Create FormData object and append data
    const formData = new FormData();
    formData.append('file', file);
    
    fetch('./upload.php', {
      method: 'POST',
      body: formData,
    })
    .then(response => {
      if (!response.ok) {
        //throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      //console.log('Upload successful:', data);
    })
    .catch(error => {
      //console.error('Error uploading data:', error);
    });
  }

  const img = new Image();

  img.onload = imgCallback;

  img.src = event.target.result;

}





function initPaste() {
  // window.addEventListener('paste', ... or
  document.addEventListener('paste', function (event) {
    var items = (event.clipboardData || event.originalEvent.clipboardData).items;
    console.log(JSON.stringify(items)); // will give you the mime types
    for (let index in items) {
      var item = items[index];
      if (item.kind === 'file') {
        var blob = item.getAsFile();
        loadFile(blob);
      }
    }
  });
}

function download() {
  var link = document.createElement('a');
  link.download = filename + '.png';
  link.href = document.getElementById('mainCanvas').toDataURL();
  link.click();
}